import type { SuggestedActions } from "app/pages/sales-intelligence/modules/suggestions/types";
import type { IFetchService } from "app/services/fetchService";
import type { GetRequestOptions } from "app/services/fetchService";

export const createSuggestionsApiService = (fetchService: IFetchService) => {
    return {
        fetchSuggestionActions: (options?: Readonly<GetRequestOptions>): Promise<SuggestedActions> => {
            return fetchService.get(`/sales-api/home/quick-actions`, undefined, options);
        },
    };
};
